export default {
  "content": "<path d=\"M12 17a2 2 0 110 4 2 2 0 010-4zM21 13H3v-2h18v2zM12 3a2 2 0 110 4 2 2 0 010-4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};